module.exports = __webpack_public_path__ + "static/media/mitsubishi_logo.4c66d1d0.png";